import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'


interface CommonState {
  isLMSUser: boolean | null
  isLoanExpired: boolean
  foreCloseReason:any,
  phoneNumbder : string
  // Add the index signature for dynamic properties
  [key: string]: any;  // This allows any new key with any value to be added
}



// Define the initial state using that type
const initialState : CommonState = {
    isLMSUser:null,
    isLoanExpired:false,
    foreCloseReason:{},
    phoneNumber : ''
}

export const commonSlice = createSlice({
  name: 'commonDetails',
  initialState,
  reducers: {
    clearCommonStore: (state) => {
      state.isLMSUser = null;
      state.isLoanExpired = false;
      state.foreCloseReason = {};
      state.phoneNumber = '';
      // Reset any other properties as needed
    },
    updateLoanExpiryState: (state, action: PayloadAction<Pick<CommonState, 'loanExpired'>>) => {
      state.isLoanExpired = action.payload.loanExpired;
    },
    updateForeCloseReason: (state, action: PayloadAction<Pick<CommonState, 'foreCloseReason'>>) => {
      state.foreCloseReason = action.payload;
    },
    updateisLMSUser: (state, action: PayloadAction<Pick<CommonState, 'isLMSUser'>>) => {
      state.isLMSUser = action.payload.isLMSUser;
    },
    updatePhoneNumber: (state, action: PayloadAction<Pick<CommonState, 'phoneNumber'>>) => {
      state.phoneNumber = action.payload.phoneNumber;
    },
  },
});

export const { clearCommonStore,updateLoanExpiryState,updateForeCloseReason,updateisLMSUser, updatePhoneNumber } = commonSlice.actions


export default commonSlice.reducer